import { ApiIdealBank, ApiIdealData } from '@api/_api/api-payment/api-ideal.model';

/**
 * Clase de utilidad para transformar los objetos que devuelve el api de inditex en los objetos que usaremos en el cms, widgets y render
 * */

export class IdealModelsTransformer {
    public static IdealBanksFromApi(apiIdealBanks: ApiIdealData): ApiIdealBank[] {
        return apiIdealBanks.banks;
    }
}
